import React from 'react'
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FaHandPointLeft } from "react-icons/fa";

export const Sidebar = ({gradientBg, fullHeight, title, subTitle, ctaText, ctaLink, helpLinks, footerText, highlightHelp}) => {
    //separate first word of string to make it block level
    const titleWords = title && title.split(' ');
    const firstWord = titleWords && titleWords[0];
    const remainingWords = title && titleWords.slice(1).join(' ');

    return (
        <aside className={`py-4 bg-primary sidebar d-flex flex-column justify-content-between ${gradientBg ? 'gradient-bg' : ''} ${fullHeight ? 'full-height rounded-5' : 'rounded-lg'}`}>
            <div>
                {
                    title ? (
                        <h1 className='mx-4 fw-bold text-white lh-1 mt-4 mb-3 pb-3 sidebar-title'>
                            <span className="d-block">{firstWord}</span> {remainingWords}
                        </h1>
                    ) : (
                        // <figure className="m-0 px-4">
                        //     <Image src='/images/logo-light.svg' className='w-100' />
                        // </figure>
                        // Replacing the <figure> with an <h1>
                        <h1 className='mx-4 text-white lh-1 mt-4 mb-3 pb-3 sidebar-title'>
                            E-Way Bill Consent
                        </h1>
                    )
                }

                {
                    subTitle && <p className='mb-0 text-white px-4 opacity-75'>{subTitle}</p>
                }
            </div>
            {/* {
                gradientBg && <p className='px-4 m-0 mb-5 text-white fs-4 lh-sm'>Indian Banks' <br/> Digital Infrastructure <br/>Company</p>
            } */}
            {gradientBg && (
                <p className='px-4 m-0 mb-5 text-white fs-4 lh-sm'>
                    {footerText ? (
                        // If footerText is provided, display it.
                        // We use dangerouslySetInnerHTML to allow for line breaks (<br/>).
                        <span dangerouslySetInnerHTML={{ __html: footerText }} />
                    ) : (
                        // Otherwise, display the default text.
                        <>
                            {/* Indian Banks' <br/> Digital Infrastructure <br/>Company */}
                        </>
                    )}
                </p>
            )}
            
            {/* Help Links section */}
            {helpLinks && (
                <div className={`bg-warning mb-5 py-3 px-4 fw-semibold ${highlightHelp ? 'help-section-pulse' : ''}`}>
                    <div className='mb-2'>Help:</div>
                    {helpLinks.map((link, index) => (
                        <Link 
                            key={index}
                            to={link.url} 
                            target="_blank" 
                            className="d-block text-dark"
                        >
                            • {link.text}
                        </Link>
                    ))}
                     {highlightHelp && (
                       <>
                       <div className="help-pointer-wrapper">
                           <FaHandPointLeft size={28} />
                       </div>
                       <style>
                           {`
                               @keyframes point-left {
                                   0% { transform: translateY(-50%) translateX(5px); }
                                   100% { transform: translateY(-50%) translateX(-5px); }
                               }
                               .help-section-pulse {
                                   position: relative;
                                   z-index: 10;
                               }
                               .help-pointer-wrapper {
                                   position: absolute;
                                   top: 50%;
                                   right: -40px;
                                   animation: point-left 0.9s ease-in-out infinite alternate;
                                   color: #212529;
                                   z-index: 20;
                                   filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
                               }
                           `}
                       </style>
                       </>
                   )}
                </div>
            )}
            
            {/* Regular CTA link */}
            {ctaText && !helpLinks && (
                <Link to={ctaLink || '#'} target="_blank" className='bg-warning mb-5 py-3 px-4 fw-semibold'>
                    {ctaText}
                </Link>
            )}
        </aside>
    )
}
